import { Component, Input, OnInit } from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk/';
import { NavigationService } from '@frk/eds-components';
import { AppStateService, WidenService } from '@services';
import { LinkService } from '@services/link.service';
import { CardContent } from '@types';
import { Logger } from '@utils/logger';

/**
 * Component Logger
 */
const logger = Logger.getLogger('BannerMultiPromoComponent');

/**
 * Promo Card Interface
 */
interface PromoCardDetails {
  title: string;
  subTitle: string;
  imageSrc?: string;
  linkBtnLabel?: string;
  linkBtnHref?: string;
  isNewWindow?: boolean;
  externalLink?: boolean;
  signInRequired?: boolean;
}

@Component({
  selector: 'ft-banner-multi-promo',
  templateUrl: './banner-multi-promo.component.html',
})
export class BannerMultiPromoComponent implements OnInit {
  /**
   * The Bloomreach component
   */
  @Input() component!: BrComponent;

  /**
   * The Bloomreach page
   */
  @Input() page!: Page;

  /**
   * Object to be passed to EDS component
   */
  promoCards: PromoCardDetails[] = [];
  marginBottom: string;

  /**
   * Constructor
   * @param widenService injected widen service
   */
  constructor(
    private appStateService: AppStateService,
    private linkService: LinkService,
    private widenService: WidenService,
    private navigationService: NavigationService
  ) {}

  /**
   * On Init
   */
  ngOnInit(): void {
    this.marginBottom = this.component.getParameters()?.marginBottom;
    this.initPromoCards();
    logger.debug('ngOnInit complete');
  }

  /**
   * Init promo cards from CardContent documents
   */
  initPromoCards() {
    // This component has 3 document parameters
    this.initPromoCard('documentOne');
    this.initPromoCard('documentTwo');
    this.initPromoCard('documentThree');
  }

  /**
   * Create `PromoCardDetails` from cardContent document
   */
  initPromoCard(documentName: string) {
    const cardContent = this.getCardContent(documentName);
    if (cardContent) {
      logger.debug(cardContent);
      this.promoCards.push({
        title: cardContent.title,
        subTitle: cardContent.content,
        imageSrc: this.widenService.getWidenAssetUrl(
          cardContent.image?.widenAsset
        ),
        linkBtnHref: this.processLink(cardContent),
        isNewWindow:
          cardContent.linkCompound?.linkCollection[0]?.target === '_blank',
        externalLink: cardContent.linkCompound?.linkCollection[0]?.external,
        linkBtnLabel: cardContent.linkCompound?.linkCollection[0]?.displayText,
        signInRequired: cardContent.linkCompound?.linkCollection[0]?.signInLink,
      });
    }
  }

  /**
   * Process the different link types
   * @param cardContent card content
   */
  processLink(cardContent: CardContent): string {
    // Process link
    let link;
    if (cardContent.linkCompound?.linkCollection?.length > 0) {
      link = this.linkService.getCTALink(
        this.page,
        cardContent.linkCompound?.linkCollection[0],
        this.appStateService?.getHomePageUrl()
      );
    }
    logger.debug('link: ' + link);
    return link;
  }

  /**
   * Get card document from page model
   */
  getCardContent(documentName: string): CardContent {
    let document = this.component.getModels<DocumentModels>()[documentName];
    document = document && this.page.getContent(document);
    return document?.getData<CardContent>();
  }
}
